(function () {
  'use strict';
  angular.module('dso')
    .component('primaryContact', {
        bindings: {
          model: '=',
          showRetypeEmail: '@',
          readOnly: '@'
        },
        controller: function() {
          var ctrl = this;
        },
        templateUrl: 'js/dso/primaryContact.html' + appVersion
      }
    );
})();
